import { NodeTree } from '@craftjs/core';
import { createAction } from 'typesafe-actions';

export const addToBuffer = createAction('Faq/AddToBuffer')<NodeTree>();
export const removeFromBuffer = createAction('Faq/RemoveFromBuffer')<string>();
